// @flow
import { getOS } from './index';
import { getAppVersion } from './electron';

let electronAppVersion;

const injectContext = (options: any = {}) => {
  const newOptions = options || {};
  newOptions.context = newOptions.context || {};
  if (window.utm_parameters) {
    newOptions.context.campaign = window.utm_parameters;
  }
  const OS = getOS();
  if (OS) {
    newOptions.context.os = { name: OS };
  }
  return newOptions;
};

export const track = (eventName: string, properties: any = {}, options: any = {}) => {
  if (window.analytics && window.analytics.track) {
    const Platform = `Ava ${window.isElectron ? 'Desktop' : 'Web'}`;
    const OS = getOS();
    const propertiesToTrack = { ...properties, Platform, OS };
    if (electronAppVersion) {
      propertiesToTrack['Desktop App Version'] = electronAppVersion;
    }
    window.analytics.track(eventName, propertiesToTrack, injectContext(options));
  }
};

export const identifyWithId = (userId: string, traits: any = {}, options: any = {}) => {
  if (window.analytics && window.analytics.identify) {
    window.analytics.identify(userId, traits, injectContext(options));
  }
};

export const identify = (traits: any = {}, options: any = {}) => {
  if (window.analytics && window.analytics.identify) {
    window.analytics.identify(traits, injectContext(options));
  }
};

export const reset = () => {
  if (window.analytics && window.analytics.reset) {
    window.analytics.reset();
  }
};

if (window.isElectron) {
  electronAppVersion = getAppVersion();
  if (electronAppVersion) {
    identify({
      'Desktop App Version': electronAppVersion,
    });
  }
}

window.onbeforeunload = () => {
  track('Application Closed');
  return null;
};
// Track LifeCycle
track('Application Opened');

// Tracking from the electron app
if (window.electronIPC) {
  window.electronIPC.onTrack((_, eventName) => {
    track(eventName);
  });
}

export const trackMicPermission = (permission: string) => {
  track('Microphone Permission Prompted', {
    result: permission,
  });
  identify({ microphone_permission: permission });
};
